/* eslint-disable */
import React, { useState } from "react";

import {
  Button,
  Modal,
  ModalBody,
  Input,
  Form,
  Row,
  Col,
  FormGroup,
  InputGroup,
  InputGroupAddon,
  
} from "reactstrap";
import Validator from "../../utils/validator";

import bgimg from "../../assets/images/ui/welcome.png";
import { useTranslation } from "react-i18next";

const PwdResetModal = (props) => {
  const { t } = useTranslation();
  const { pwdResetModal } = props.state;
  const toggle = () => {
    props.dispatch({
      type: "layout/save",
      payload: { pwdResetModal: !pwdResetModal },
    });
  };
  const [email, setEmail] = useState({
    status: "",
    msg: "",
    value: "",
  });

  const [password1, setPassword1] = useState({
    status: "",
    msg: "",
    value: "",
  });
  const [password2, setPassword2] = useState({
    status: "",
    msg: "",
    value: "",
  });

  const [openEye, setOpenEye] = useState(false);

  const eyeToggle = (e) => {
    e.preventDefault();
    setOpenEye(!openEye);
  };


  const preventJump = (e) => {
    e.preventDefault();
    toggle();
  };

  // 提交错误回调函数
  const submitErrCallback = (clear, code, msg) => {
    console.log(code, msg);
    
  };
  // 提交错误回调函数
  const submitSuccessCallback = () => {
    props.dispatch({
      type: "layout/save",
      payload: { pwdResetModal: !pwdResetModal },
    });
  };
  // 提交表单
  const submit = async (e) => {
    e.preventDefault();
    if (!window.sessionStorage.getItem("resetCode")) {
      setPassword2({
        msg: t("Code is expired, plz request a new email link"),
        value: password1.value,
        status: "danger",
      });
    }


    let values = {
      email: email.value,
      new: password1.value,
      code: window.sessionStorage.getItem("resetCode"),
      type: "pwdreset",
    };

    if (
      !password1.msg &&
      !password2.msg &&
      !email.msg &&
      password1.value &&
      password2.value &&
      email.value
    ) {
      try {
        await props.dispatch({
          type: "layout/pwdReset",
          payload: values,
          errorCallback: submitErrCallback,
          successCallback: submitSuccessCallback,
        });
      } catch (err) {
        console.log(err);
      }
    }
  };


  // 处理表单输入
  const onChange = (elmName, event) => {
    switch (elmName) {
      case "password1":
        setPassword1({
          status: "",
          msg: "",
          value: event.target.value,
        });
        break;
      case "email":
        setEmail({
          status: "",
          msg: "",
          value: event.target.value,
        });
        break;
      case "password2":
        setPassword2({
          status: "",
          msg: "",
          value: event.target.value,
        });
    }
  };

  //  失去焦点
  const onBlur = (elmName, event) => {
    switch (elmName) {
      case "email":
        verifyEmail(event.target.value);
        break;
      case "password1":
        verifyPassword1(event.target.value);
    }
  };

  const Pwd2onBlur = (password1, event) => {
    verifyPassword2(event.target.value, password1);
  };

  //  验证表单
  const verifyEmail = (email) => {
    if (!email) {
      setEmail({
        status: "danger",
        msg: t("Email is required!"),
      });
      return false;
    }

    if (!Validator.isEmail(email)) {
      setEmail({
        status: "warning",
        msg: t("Check the formatting of that and try again!"),
      });
      return false;
    }
    setEmail({
      status: "success",
      value: email,
    });

    return true;
  };

  //  验证表单
  const verifyPassword1 = (password1) => {
    if (!password1) {
      setPassword1({
        status: "danger",

        msg: t("Password is required!"),
      });
      return false;
    }

    if (
      password1.length < 8 ||
      password1.length > 20 ||
      !/(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])/.test(password1)
    ) {
      setPassword1({
        status: "warning",
        msg: t(
          "The password must be 8-20 digits and must include all uppercase, lowercase and numbers."
        ),
      });
      return false;
    }
    setPassword1({
      status: "success",
      value: password1,
    });

    return true;
  };

  const verifyPassword2 = (password2, password1) => {
    if (!password2) {
      setPassword2({
        status: "danger",
        msg: t("Password is required!"),
      });
      return false;
    }

    if (password1 !== password2) {
      setPassword2({
        status: "warning",
        msg: t("Password not match"),
        value: password2,
      });
      return false;
    }

    setPassword2({
      status: "success",
      value: password2,
    });
    return true;
  };

  return (
    <div>
      <Row>
        <Modal
          isOpen={pwdResetModal}
          toggle={toggle}
          className="modal-fullscreen-sm-down modal4 custom-modal"
          style={{ display: "block", paddingLeft: " 0px" }}
          size="lg"
        >
          <ModalBody style={{ padding: "0" }}>
            <Row>
              <Col
                md="3"
                lg="5"
                className="modal-bg-img animate__animated animate__rubberBand d-none d-sm-block"
                style={{ backgroundImage: `url(${bgimg})` }}
              ></Col>
              <Col md="9" lg="7">
                <div className="modal-bg">
                  <h4 className="font-light">{t("Reset password")}</h4>
                  <span className="font-light text-danger ">
                    {t(
                      "The password must be 8-20 digits and must include all uppercase, lowercase and numbers."
                    )}
                  </span>
                  <Form className="m-t-30">
                    <Row className="row">
                      <Col lg="12">
                        <FormGroup
                          className={email.status ? "has-" + email.status : ""}
                        >
                          <Input
                            className={
                              email.status
                                ? "form-control mb-2 form-control-" +
                                  email.status
                                : "form-control mb-2 "
                            }
                            type="email"
                            placeholder={t("Please enter Email address")}
                            value={email.value}
                            onChange={onChange.bind(this, "email")}
                            onBlur={onBlur.bind(this, "email")}
                          />
                          <div className="form-control-feedback">
                            {email.msg}
                          </div>
                        </FormGroup>
                      </Col>
                      <Col lg="12">
                        <FormGroup
                          className={
                            password1.status ? "has-" + password1.status : ""
                          }
                        >
                          <InputGroup>
                            <Input
                              className={
                                password1.status
                                  ? "form-control mb-2 form-control-" +
                                    password1.status
                                  : "form-control mb-2 "
                              }
                              type={openEye ? "text" : "password"}
                              placeholder={t("New password")}
                              value={password1.value}
                              onChange={onChange.bind(this, "password1")}
                              onBlur={onBlur.bind(this, "password1")}
                            />
                            <InputGroupAddon addonType="append">
                              <Button
                                className="btn btn-sm mb-2"
                                color="info"
                                onClick={eyeToggle.bind(this)}
                              >
                                {" "}
                                <span className="btn-label">
                                  <i
                                    className={
                                      openEye ? "fa fa-eye" : "fa fa-eye-slash"
                                    }
                                  ></i>
                                </span>{" "}
                              </Button>
                            </InputGroupAddon>
                          </InputGroup>
                          <div className="form-control-feedback">
                            {password1.msg}
                          </div>
                        </FormGroup>
                      </Col>
                      <Col lg="12">
                        <FormGroup
                          className={
                            password2.status ? "has-" + password2.status : ""
                          }
                        >
                          <InputGroup>
                            <Input
                              className={
                                password2.status
                                  ? "form-control mb-2 form-control-" +
                                    password2.status
                                  : "form-control mb-2 "
                              }
                              type={openEye ? "text" : "password"}
                              placeholder={t("Confirm password")}
                              value={password2.value}
                              onChange={onChange.bind(this, "password2")}
                              onBlur={Pwd2onBlur.bind(this, password1.value)}
                            />
                            <InputGroupAddon addonType="append">
                              <Button
                                className="btn btn-sm mb-2"
                                color="info"
                                onClick={eyeToggle.bind(this)}
                              >
                                {" "}
                                <span className="btn-label">
                                  <i
                                    className={
                                      openEye ? "fa fa-eye" : "fa fa-eye-slash"
                                    }
                                  ></i>
                                </span>{" "}
                              </Button>
                            </InputGroupAddon>
                          </InputGroup>
                          <div className="form-control-feedback">
                            {password2.msg}
                          </div>
                        </FormGroup>
                      </Col>
                      <Col className="col-lg-12 d-flex no-block justify-content-center">
                        <Button
                          className="btn btn-md btn-success-gradiant text-white btn-arrow"
                          onClick={submit}
                        >
                          <span>
                            {t("Confirm")} <i className="ti-arrow-right"></i>
                          </span>
                        </Button>{" "}
                      </Col>
                    </Row>
                  </Form>
                </div>
              </Col>
              <a
                href="#"
                className="close-btn d-flex align-items-center justify-content-center"
                data-bs-dismiss="modal"
                aria-hidden="true"
                onClick={preventJump}
              >
                ×
              </a>
            </Row>
          </ModalBody>
        </Modal>
      </Row>
    </div>
  );
};

export default PwdResetModal;
